import { useDataValue } from 'Simple/Data.js'
import { useState, useEffect, useMemo } from 'react'
import { storage } from 'Data/helpers.js'
import { STORAGE_KEY_IMAGE_CAPTURE } from 'Data/constants.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let questions = useDataValue({
    context: 'imageCapture',
    path: 'questions',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'flow_shortcuts',
    viewPath: props.viewPath,
    path: 'id',
  })

  let [previousState, setPreviousState] = useState(null)

  useEffect(() => {
    let fetchPreviousState = async () => {
      let storedValue = await storage.getItem(
        `${STORAGE_KEY_IMAGE_CAPTURE}_${id}`
      )
      if (storedValue) {
        setPreviousState(JSON.parse(storedValue))
      }
    }

    fetchPreviousState()
  }, [id])

  let newState = useMemo(
    () => ({ ...data, flowQuestions: questions.map(item => item.id) }),
    [questions, data]
  )

  return useMemo(() => {
    if (!data) return data

    // Use parsed previous state if it exists, otherwise use the new state
    return {
      ...(previousState ?? newState),
    }
  }, [data, previousState, newState])
}
